module.exports = __webpack_public_path__ + "img/sell.31de3a2f.svg";